<template>
  <vs-popup
    class="view-bookings-on-deactivated-tables-popup"
    title="Bookings on deactivated tables"
    :active.sync="showThisPopup"
  >
    <div class="bookings-list">
      <div v-if="enhancedBookingsOnDeactivatedTables">
        <vs-row
          vs-w="12"
          v-if="enhancedBookingsOnDeactivatedTables.length === 0"
        >
          <vs-col vs-lg="3">
            <div>No bookings</div>
          </vs-col>
        </vs-row>

        <div
          v-for="(group, index) in groupedEnhancedBookings"
          :key="'group-' + index"
          class="bg-grey shadow-lg mb-4 p-2 rounded-lg"
        >
          <h3>{{ formatDate(group[0]) }}</h3>
          <div
            v-for="enhBooking in group"
            :key="enhBooking.booking.id"
            class="bg-white shadow-lg mt-2 p-4 px-6 rounded-lg cursor-pointer"
                @click="popupEditBooking.show(enhBooking)"
          >
            <booking-list-item
              :enhanced-booking="enhBooking"
              :show-actions="false"
            ></booking-list-item>
          </div>
        </div>
      </div>
    </div>

    <!-- <popup-edit-booking
      ref="popupEditBooking"
      :venue-details="activeVenueDetails"
      @booking-updated="handleBookingUpdated"
    /> -->
  </vs-popup>
</template>

<script>
import * as _ from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import PopupEditBooking from "../popups/PopupEditBooking.vue";
import BookingListItem from "../components/BookingListItem.vue";

export default {
  components: {
    BookingListItem,
    PopupEditBooking,
  },
  props: {
    popupEditBooking: Object
  },
  data() {
    return {
      showThisPopup: false,
    };
  },
  computed: {
    ...mapGetters({
      enhancedBookingsOnDeactivatedTables:
        "marcomBooking/enhancedBookingsOnDeactivatedTables",
    }),
    groupedEnhancedBookings: {
      get() {
        return _.sortBy(
          _.groupBy(
            this.enhancedBookingsOnDeactivatedTables,
            (enh) => moment(enh.booking.arrival).startOf("day"),
            (g) => g
          )
        );
      },
    },
  },
  methods: {
    show() {
      this.showThisPopup = true;
    },
    formatDate(enhancedBooking) {
      return moment(enhancedBooking.booking.arrival).format('DD-MM-YYYY');
    }
  },
};
</script>

<style lang="scss" scoped>
.view-bookings-on-deactivated-tables-popup::v-deep .vs-popup {
  width: 1080px;

  .vs-popup--content {
    overflow: hidden;

    > .bookings-list {
      max-height: calc(100vh - 225px);
      overflow: auto;
    }
  }
}
</style>
